<template>
  <div class="animated fadeIn">
    <!-- Modal Component -->
    <b-modal
      ref="deleteModal"
      hide-footer
      title="장기보고서 삭제"
    >
      <p class="my-4">
        장기보고서를 삭제하겠습니까?
      </p>
      <b-button
        variant="outline-danger"
        block
        @click="deleteApplyForm()"
      >
        삭제(Delete)
      </b-button>
      <b-button
        variant="outline-primary"
        block
        @click="$refs.deleteModal.hide()"
      >
        취소(Cancel)
      </b-button>
    </b-modal>
    <!-- 이제부터 신청 정보 -->
    <b-row
      align-h="start"
    >
      <b-col
        md="10"
        class="text-left"
      >
        <h4>
          {{ !userEnabled ? '장기장학생 보고서를 작성해주세요' : '장기장학생 보고서 제출 완료' }}
          <b-badge :variant="userEnabled ? 'success' : 'danger'">
            {{ userEnabled ? '제출완료' : '제출안함' }}
          </b-badge>
        </h4>
      </b-col>
      <b-col
        v-show="(!noEdit && (freezing && certFreezing))"
        md="2"
        class="text-right"
      >
        <b-button
          class="mb-5"
          variant="warning"
          size="md"
          @click="setFreezing(false)"
        >
          <b>수정하기</b>
        </b-button>
      </b-col>
    </b-row>
    <!-- 학교 정보 -->
    <b-row>
      <b-col md="2">
        <b-form-group
          name="part"
          label="부서"
          label-for="part"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-select
            v-model="part"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            :options="partOptions"
            name="part"
            :state="isValid('part')"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="schoolSet"
          label="학교"
          label-for="school"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="school"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="school"
            placeholder="학교명(school/univ.)"
            :state="isValid('school')"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="majorSet"
          label="전공"
          label-for="major"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="major"
            :disabled="freezing"
            name="major"
            placeholder="전공(depart/major)"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          name="gradeSet"
          label="학년"
          label-for="grade"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="grade"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="grade"
            :state="isValid('grade')"
            placeholder="학년(grade)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <apply-any
      :name="'works'"
      :email="email"
      :apply-id="applyId"
      :title="'현재 내가 누리고 있는 말씀의 흐름과 그에 대한 나만의 작품(형식자유) 제출.(Submit the flow of the Word you are currently enjoying and your masterpiece(any type) about it.)'"
      placeholder="Top: 옵션(optional) / Summit&연속수여: 필수(required)"
      :read-only="freezing"
      @updateFileAll="updateWorkAll"
    />
    <apply-cert
      :email="email"
      :apply-id="applyId"
      :read-only="certFreezing || part === '초등56부'"
      :schls-type="schlsType"
      @updateCertAll="updateCertAll"
    />
    <!-- 계좌 정보 -->
    <b-row>
      <b-col md="4">
        <b-form-group
          name="bankSet"
          label="은행"
          label-for="bank"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="bank"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="bank"
            :state="isValid('bank')"
            placeholder="은행(bank)"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="accountSet"
          label="계좌번호"
          label-for="account"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="account"
            v-validate.initial="veeNumber"
            :disabled="freezing"
            name="account"
            :state="isValid('account')"
            placeholder="숫자만 입력(bank account only numbers)"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="accountHolderSet"
          label="계좌주"
          label-for="accountHolder"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="accountHolder"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="accountHolder"
            :state="isValid('accountHolder')"
            placeholder="예금주 입력(Bank Account Holder)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 기도후원자 -->
    <b-row>
      <b-col md="12">
        <b-form-group
          name="pSupporter"
          label="기도후원자(나의 기도 후원자 또는 영적멘토를 공유해주세요)"
          label-for="pSupporter"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="pSupporter"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="pSupporter"
            :state="isValid('pSupporter')"
            placeholder="기도후원자(My prayer supporter)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 자유 서술  -->
    <b-row>
      <b-col md="12">
        <b-form-group
          name="lontermReportSet"
          :label="'자유 서술(현재 글자수: ' + String(longtermReport.length) + '자)'"
          label-for="longtermReport"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-textarea
            id="longtermReport"
            v-model="longtermReport"
            :disabled="freezing"
            placeholder="장기장학생 보고서를 자유롭게 성의있게 작성(500자 초과)"
            :rows="20"
            :max-rows="20"
            :state="longtermReport.length === 0 ? null : (longtermReport.length > 500)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 인턴십 지원 여부 -->
    <b-row>
      <b-col md="4">
        <b-form-group
          name="itsSet"
          label="인턴십 신청(Request for Intership)"
          label-for="its"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-select
            v-model="its"
            :disabled="freezing"
            :options="itsOptions"
            name="its"
          />
        </b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group
          name="itsDetailSet"
          label="인턴십 요청사항"
          label-for="itsDetail"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="itsDetail"
            :disabled="freezing"
            name="itsDetail"
            :readonly="isNoIts"
            placeholder="인턴십 요청사항(any request related to the internship)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!freezing || !certFreezing">
      <b-col
        v-if="userEnabled && !freezing"
        :md="6"
        class="text-center"
      >
        <b-button
          class="mb-5"
          variant="danger"
          @click="$refs.deleteModal.show()"
        >
          삭제(Remove)
        </b-button>
      </b-col>
      <b-col
        :md="userEnabled ? 6 : 12"
        class="text-center"
      >
        <b-button
          :disabled="freezing && certFreezing"
          class="mb-5"
          variant="success"
          block
          @click="validateUpdateDetailInfo()"
        >
          제출(Submit)
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'
import ApplyCert from './ApplyCert'
import ApplyAny from './ApplyAnyFile'

export default {
  name: 'ApplyInfo',
  components: { ApplyCert, ApplyAny },
  props: {
    email: {
      type: String,
      required: true
    },
    applyId: {
      type: String,
      required: true
    },
    lock: {
      type: Boolean,
      default: false
    },
    summitLock: {
      type: Boolean,
      default: false
    },
    initialReadOnly: {
      type: Boolean,
      required: true
    },
    longterm: {
      type: Number,
      required: true
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      its: api.ITSDETAIL[0],
      itsOptions: api.ITSDETAIL,
      itsDetail: '',
      serverUri: api.serverURI,
      bank: '',
      account: '',
      accountHolder: '',
      pSupporter: '',
      grade: '',
      major: '',
      school: '',
      part: '',
      partOptions: api.PARTLIST,
      schlsType: 'TOP',
      longtermReport: '',
      veeNumber: {
        required: true,
        regex: /^(\d+)$/
      },
      veeRequired: {
        required: true
      },
      pdfCertAll: [],
      workAll: [],
      isReadOnly: this.initialReadOnly,
      userEnabled: false
    }
  },
  computed: {
    freezing () {
      return (this.lock || this.isReadOnly)
    },
    certFreezing () {
      return (this.summitLock || this.isReadOnly)
    },
    isNoIts () {
      return this.its === this.itsOptions[0]
    }
  },
  watch: {
    part: function (newVal) {
      if (newVal === '초등56부') {
        this.schlsType = 'TOP'
      }
    }
  },
  mounted () {
    this.getApplyForm()
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    setFreezing (val) {
      this.isReadOnly = val
    },
    deleteApplyForm () {
      api.request('delete', '/apply/delete?applyId=' + this.applyId)
        .then(response => {
          var data = response.data
          this.$store.commit('setSubmit', 0)
          alert(data.msg)
          this.$router.go()
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    getApplyForm () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      this.$validator.reset()
      api.request('get', '/apply/check?applyId=' + this.applyId + '&info=1&ic=all')
        .then(response => {
          var data = response.data
          if (data.check === 0) {
            this.setFreezing(false)
          } else {
            this.userEnabled = true
            this.parseApply(data)
            this.setFreezing(true)
            this.$validator.reset()
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    parseApply (data) {
      this.schlsType = data.schlsType
      this.part = data.part
      this.school = data.school
      this.major = data.major
      this.grade = data.grade
      this.bank = data.bank
      this.pSupporter = data.pSupporter
      this.account = data.account
      this.accountHolder = data.accountHolder
      this.longtermReport = data.longtermReport
      this.its = api.ITSDETAIL[data.its]
      this.itsDetail = data.itsDetail
    },
    updateCertAll (certs, toTop) {
      this.pdfCertAll = certs
      if (this.pdfCertAll.length > 0) {
        this.schlsType = 'SUMMIT'
        return
      }
      if (toTop) {
        this.schlsType = 'TOP'
      }
    },
    updateWorkAll (certs) {
      this.workAll = certs
    },
    alertSuccess () {
      this.setFreezing(true)
      this.$validator.reset()
      alert('등록이 완료되었습니다.')
      this.$router.push('/dashboard')
    },
    alertFail (msg) {
      alert(msg)
    },
    alertRetry () {
      alert('빨간색으로 표시된 상자를 확인해주세요.(Check all the red boxes)')
    },
    validateUpdateDetailInfo () {
      this.$validator.validate()
        .then(valid => {
          this.updateDetailInfo(valid)
        })
    },
    updateDetailInfo (valid) {
      if (!valid) {
        // 제대로 확인 하라고 에러 메시지
        this.alertRetry()
        return
      }
      if (this.longtermReport.length <= 500) {
        alert('레포트는 500자 초과 작성하세요(The report must be greater than 500 characters)')
        return
      }
      if (this.workAll.length === 0) {
        alert('장기장학생은 반드시 작품을 제출해야 합니다(Your masterpiece is required)')
        return
      }
      // post arg 세팅
      var postArg = {}
      postArg['applyId'] = this.applyId
      postArg['schlsType'] = this.schlsType
      postArg['part'] = this.part
      postArg['school'] = this.school
      postArg['major'] = this.major
      postArg['grade'] = this.grade
      postArg['bank'] = this.bank
      postArg['pSupporter'] = this.pSupporter
      postArg['account'] = this.account
      postArg['accountHolder'] = this.accountHolder
      postArg['its'] = Number(this.its.split('.')[0]) - 1
      postArg['itsDetail'] = this.itsDetail
      postArg['certs'] = this.pdfCertAll
      postArg['works'] = this.workAll
      postArg['email'] = this.email
      postArg['longtermReport'] = this.longtermReport
      postArg['longterm'] = this.longterm
      postArg['modifiedDate'] = api.currentUnixTime()

      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('post', '/apply/regist', postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
             400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.$store.commit('setSubmit', 1)
            this.alertSuccess()
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    }
  }
}
</script>

<style>
</style>
